import dev from './dev.json';
import staging from './staging.json';
import newstaging from './new-staging.json';
import prod from './prod.json';

export enum Env {
  Dev = 'DEV',
  Staging = 'STAGING',
  Prod = 'PROD',
  Newstaging = "NEWSTAGING"
}

export default (env: Env) => {
  switch (env) {
    case Env.Prod:
      return prod;
    case Env.Staging:
      return staging;
    case Env.Newstaging:
      return newstaging;
    case Env.Dev:
    default:
      return dev;
  }
};
